// extracted by mini-css-extract-plugin
module.exports = {"scrollTime":"700ms"};